module.exports = __webpack_public_path__ + "static/media/git.fef702d6.png";